import React from 'react';

import PasswordResetForm from '@app/components/ForgotPassword/PasswordResetForm';
import type {DzrGetStaticProps, DzrPage} from '@app/types/next';
import {COBRANDED_APPS} from '@app/types/next';
import type {GetStaticPaths} from 'next';
import {getTemplate} from '@app/modules/server/template';
import {AuthLayout} from '@app/components/Layouts/pages/AuthLayout';
import {useUnloggedController} from '@app/hooks/controllers/useAuthController';
import {getStaticTranslations} from '@app/modules/translations';
import {AccountSection} from '@app/components/Layouts/elements';

const ResetPasswordPage: DzrPage = () => {
	const {isLoading} = useUnloggedController();
	return (
		<AuthLayout isLoading={isLoading}>
			<AccountSection>
				<PasswordResetForm />
			</AccountSection>
		</AuthLayout>
	);
};

export const getStaticProps: DzrGetStaticProps = async ({
	locale = '',
	params,
}) => {
	const translations = await getStaticTranslations(locale, {
		appName: params?.appName,
		additionnalNamespaces: ['error'],
	});
	const {appName, colorMode, template} = getTemplate(params?.appName);
	return {
		props: {
			appName,
			colorMode,
			template,
			...translations,
		},
	};
};

export const getStaticPaths: GetStaticPaths = ({locales}) => {
	const paths: {locale: string; params: {appName: string}}[] = [];
	locales?.forEach((locale) => {
		COBRANDED_APPS.forEach((cobrandedApp) => {
			paths.push({
				params: {appName: cobrandedApp.toLowerCase()},
				locale,
			});
		});
	});
	return {
		paths,
		fallback: false,
	};
};

export default ResetPasswordPage;
